<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, defineProps, defineExpose } from 'vue';

/*==================================================================*/
/*================ IMPORTS COMPONENTES =============================*/
/*==================================================================*/

import ModalDialogoBase from '@/components/v2/base/ModalDialogoBase/ModalDialogoBase.vue';
import BotaoTextoBase from '@/components/v2/base/BotaoTextoBase/BotaoTextoBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    maxWidth: {
        type: String,
        default: '400'
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

/*==================================================================*/
/*================== MODAL DIALOGO REF ==============================*/
/*==================================================================*/

const modalDialogoBaseRef = ref(null);

/*==================================================================*/
/*================== ABRIR / FECHAR MODAL ===========================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalDialogoBaseRef.value?.abrirModal();

};

const fecharModal = async () => {

    await modalDialogoBaseRef.value?.fecharModal();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalDialogoBase
        ref="modalDialogoBaseRef"
        :max-width="props.maxWidth"
    >

        <template #header>

            <div class="c-modal-informacao-header">

                <v-icon color="#1976D2">mdi-alert-circle-outline</v-icon>

                <slot name="header"></slot>

            </div>

        </template>

        <template #body>
            <slot name="body"></slot>
        </template>

        <template #footer>

            <v-spacer></v-spacer>

            <BotaoTextoBase
                color="#1976D2"
                :disabled="props.disabled"
                :click="fecharModal"
            >
                Fechar
            </BotaoTextoBase>

        </template>

    </ModalDialogoBase>

</template>

<style scoped>

.c-modal-informacao-header{
    display: flex;
    align-items: center;
    gap: 8px;
}

</style>
